import Button from "@amzn/awsui-components-react/polaris/button";
import Alert from "@amzn/awsui-components-react/polaris/alert";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import useQueryGetReportDownloadUrl from "Api/useQueryGetReportDownloadUrl";

const FULL_REPORT_FILE = "full_report.csv";

interface DownloadFullReportButtonProps {
  readonly folderName: string;
}

const DownloadFullReportButton = ({ folderName }: DownloadFullReportButtonProps) => {
  const { mutate, isLoading, error } = useQueryGetReportDownloadUrl();

  const handleDownload = () => {
    mutate(folderName + FULL_REPORT_FILE, {
      onSuccess: ({ url }) => {
        window.location.assign(url);
      },
    });
  };

  return (
    <SpaceBetween direction="vertical" size="xs">
      <Button onClick={handleDownload} loading={isLoading} iconName="download">
        Download full report (CSV)
      </Button>
      {error && <Alert type="error">{error}</Alert>}
    </SpaceBetween>
  );
};

export default DownloadFullReportButton;
